(function () {
  if (window.__scLanguageSwitcherInit) return;
  window.__scLanguageSwitcherInit = true;

  var KNOWN_FLAGS = ['de', 'it', 'en', 'fr', 'es', 'nl', 'pt', 'pl'];

  function getFlagModifier(code) {
    var normalized = (code || '').toLowerCase();
    return KNOWN_FLAGS.indexOf(normalized) !== -1 ? normalized : 'unknown';
  }

  function createFlagElement(code) {
    var modifier = getFlagModifier(code);
    var flag = document.createElement('span');
    flag.className = 'sc-language-flag sc-language-flag--md sc-language-flag--' + modifier;
    flag.setAttribute('role', 'img');

    if (modifier === 'unknown') {
      flag.setAttribute('data-sc-language-code', code.toUpperCase());
    }

    var hiddenLabel = document.createElement('span');
    hiddenLabel.className = 'visually-hidden';
    hiddenLabel.textContent = code.toUpperCase();
    flag.appendChild(hiddenLabel);

    return flag;
  }

  function getWeglotLanguages() {
    if (!window.Weglot || !Weglot.options) return [];

    var languages = Weglot.options.languages.map(function (entry) {
      return entry.language_to;
    });

    languages.push(Weglot.options.language_from);

    return languages.filter(function (code, index, list) {
      return code && list.indexOf(code) === index;
    });
  }

  function updateCurrentLabels(lang) {
    document.querySelectorAll('[data-sc-weglot-current]').forEach(function (node) {
      var container = node.closest('.sc-language-switcher');
      var isHeader = container && container.classList.contains('sc-language-switcher--header');
      node.textContent = isHeader ? lang.toUpperCase() : Weglot.getLanguageName(lang);
    });

    document.querySelectorAll('[data-sc-weglot-current-flag]').forEach(function (node) {
      node.innerHTML = '';
      node.appendChild(createFlagElement(lang));
    });

    document.querySelectorAll('[data-sc-weglot-list] .sc-language-switcher__menu-link, [data-sc-weglot-list] .popout-list__item').forEach(function (item) {
      var link = item.matches('a') ? item : item.querySelector('a, button');
      var code = link ? link.getAttribute('lang') : '';
      var isCurrent = code === lang;

      if (item.classList.contains('popout-list__item')) {
        item.classList.toggle('popout-list__item--current', isCurrent);
      } else {
        item.classList.toggle('sc-language-switcher__menu-link--current', isCurrent);
        if (link) {
          link.setAttribute('aria-current', isCurrent ? 'true' : 'false');
        }
      }
    });
  }

  function buildWeglotSwitchers() {
    var containers = document.querySelectorAll('[data-sc-weglot-language-switcher]');
    if (!containers.length) return true;

    var languages = getWeglotLanguages();
    if (!languages.length) return false;

    containers.forEach(function (container) {
      if (container.dataset.scWeglotBuilt === 'true') return;

      var list = container.querySelector('[data-sc-weglot-list]');
      if (!list) return;

      container.dataset.scWeglotBuilt = 'true';
      list.innerHTML = '';

      var isMenu = container.classList.contains('sc-language-switcher--menu');
      var isHeader = container.classList.contains('sc-language-switcher--header');
      var currentLang = Weglot.getCurrentLang();

      languages.forEach(function (code) {
        var isCurrent = code === currentLang;

        if (isMenu) {
          var menuItem = document.createElement('li');
          menuItem.className = 'sc-language-switcher__menu-item nav-user__item';

          var menuLink = document.createElement('a');
          menuLink.className = 'nav-user__link sc-language-switcher__menu-link';
          menuLink.href = '#Weglot-' + code;
          menuLink.setAttribute('lang', code);
          menuLink.textContent = Weglot.getLanguageName(code);

          if (isCurrent) {
            menuLink.classList.add('sc-language-switcher__menu-link--current');
            menuLink.setAttribute('aria-current', 'true');
          }

          menuItem.appendChild(menuLink);
          list.appendChild(menuItem);
        } else if (isHeader) {
          if (isCurrent) return;

          var flagItem = document.createElement('li');
          flagItem.className = 'popout-list__item sc-language-switcher__flag-item';

          var flagOption = document.createElement('a');
          flagOption.className = 'popout-list__option sc-language-switcher__flag-option';
          flagOption.href = '#Weglot-' + code;
          flagOption.setAttribute('lang', code);
          flagOption.appendChild(createFlagElement(code));

          var hiddenName = document.createElement('span');
          hiddenName.className = 'visually-hidden';
          hiddenName.textContent = Weglot.getLanguageName(code);
          flagOption.appendChild(hiddenName);

          flagItem.appendChild(flagOption);
          list.appendChild(flagItem);
        } else {
          var listItem = document.createElement('li');
          listItem.className = 'popout-list__item';

          if (isCurrent) {
            listItem.classList.add('popout-list__item--current');
          }

          var option = document.createElement('a');
          option.className = 'popout-list__option';
          option.href = '#Weglot-' + code;
          option.setAttribute('lang', code);

          if (isCurrent) {
            option.setAttribute('aria-current', 'true');
          }

          var label = document.createElement('span');
          label.textContent = Weglot.getLanguageName(code);
          option.appendChild(label);
          listItem.appendChild(option);
          list.appendChild(listItem);
        }
      });

      container.hidden = false;
    });

    updateCurrentLabels(Weglot.getCurrentLang());
    return true;
  }

  function bindWeglotEvents() {
    if (window.__scLanguageSwitcherEventsBound) return;
    window.__scLanguageSwitcherEventsBound = true;

    Weglot.on('languageChanged', function (lang) {
      updateCurrentLabels(lang);
    });
  }

  function init() {
    if (!buildWeglotSwitchers()) return;

    bindWeglotEvents();
  }

  function boot() {
    if (typeof Weglot !== 'undefined') {
      init();
      Weglot.on('initialized', init);
      return;
    }

    document.addEventListener('DOMContentLoaded', function () {
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;

        if (typeof Weglot !== 'undefined') {
          window.clearInterval(timer);
          boot();
        } else if (attempts > 50) {
          window.clearInterval(timer);
        }
      }, 100);
    });
  }

  boot();
})();
